module.exports = __webpack_public_path__ + "static/media/img-residence-card.15d3748a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-residence-card.jpg
// module id = 13565
// module chunks = 0